<template>
  <v-card class="d-flex flex-column align-center pa-6">
    <AndroidPermissionImage v-if="!isIOS" />
    <iOSPermissionImage v-else />
    <div class="d-flex justify-center mt-6">
      <div>
        <PointingGuy />
      </div>
      <div
        class="ml-4 d-flex flex-column justify-center"
        style="line-height: 16px"
      >
        <Subtitle :line-height="16" :font-size="0.875">
          {{ t$(".subtitle") }}
        </Subtitle>
        <TextBody :font-size="0.875">
          <div v-html="t$('.description')"></div>
        </TextBody>
      </div>
    </div>
    <Button @click="$emit('requestPermission')" class="mt-6" :block="true">{{
      t$(".button")
    }}</Button>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import AndroidPermissionImage from "./assets/AndroidPermission.svg"
import iOSPermissionImage from "./assets/iOSPermissions.svg"
import PointingGuy from "./assets/PointingGuy.svg"
import TextBody from "components/UI/TextBody.vue"
import Subtitle from "components/UI/Subtitle.vue"
import Button from "components/UI/Button.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "NotificationPermissionWizard",
  components: {
    Button,
    Subtitle,
    TextBody,
    AndroidPermissionImage,
    PointingGuy,
    iOSPermissionImage,
  },
  props: { isIOS: { type: Boolean, required: true } },
  setup(props, context) {
    const { t$ } = useTranslate("components.push_wizard.notification_wizard")
    return {
      t$,
    }
  },
})
</script>
